import { APP_INITIALIZER, NgModule, Provider } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

// import { CustomFormsModule } from 'ngx-custom-validators';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule, RoutingComponents } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppConfig } from '../app/app.configsettings';
import { AppOfflineStore } from '../app/app.offlineService';
import { QuestionPreviewComponent } from './Component/question-management/question-preview/question-preview.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { RteWorksComponent } from './Component/rte-works/rte-works.component';
// import { RichTextEditorModule, ToolbarService, LinkService, ImageService,
// HtmlEditorService,FileManagerService,TableService } from '@syncfusion/ej2-angular-richtexteditor';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpErrorHandlerService } from './Services/config/http-error-handler.service';
import { MessageServiceService } from './Services/config/message-service.service';
import { SampleService } from './Services/sample.service';
import { SubjectManagementComponent } from './Component/subject-management/subject-management.component';
import { MasterComponent } from './Component/master/master.component';
import { DatePipe } from '@angular/common';
import { QuillModule } from 'ngx-quill';

import { CommonModule } from '@angular/common';

import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';

import { OverlayContainer, ToastrModule } from 'ngx-toastr';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { PdfViewerComponent } from './Component/pdf-viewer/pdf-viewer.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { QuestionSubmitForReviewComponent } from './Component/question-management/question-submit-for-review/question-submit-for-review.component';
import { ContentManagementComponent } from './Component/content-management/content-management.component';
import { ContentManagementTreeComponent } from './Component/content-management/content-management-tree/content-management-tree.component';
import { ContentStudymaterialListComponent } from './Component/content-management/content-studymaterial-list/content-studymaterial-list.component';
import { ContentStudyUnitComponent } from './Component/content-management/content-study-unit/content-study-unit.component';
import { ContentStudyunitTopicsComponent, ContentStudyunitTopicsNodeComponent } from './Component/content-management/content-studyunit-topics/content-studyunit-topics.component';
import { ContentStudyUnitSubjectComponent } from './Component/content-management/content-study-unit-subject/content-study-unit-subject.component';
import { ContentAddEditStudymaterialComponent } from './Component/content-management/content-add-edit-studymaterial/content-add-edit-studymaterial.component';
import { ContentPreviewComponent } from './Component/content-management/content-preview/content-preview.component';
import { ContentForReviewComponent } from './Component/content-management/content-for-review/content-for-review.component';
import { ContentReviewcommentsComponent } from './Component/content-management/content-reviewcomments/content-reviewcomments.component';
import { QuestionManagementComponent } from './Component/question-management/question-management.component';
import { QuestionMasterComponent } from './Component/question-management/question-master/question-master.component';
import { QuestionListComponent } from './Component/question-management/question-list/question-list.component';
import { QuestionBodyAddEditComponent } from './Component/question-management/question-body-add-edit/question-body-add-edit.component';
import { AnswerChoiceAddEditComponent } from './Component/question-management/answer-choice-add-edit/answer-choice-add-edit.component';
import { AnswerChoiceNoteComponent } from './Component/question-management/answer-choice-note/answer-choice-note.component';
import { QuestionstatusHistoryComponent } from './Component/question-management/questionstatus-history/questionstatus-history.component';
import { QuillRTEComponent } from './Component/quill-rte/quill-rte.component';

import { CompressionServiceService } from './Services/compression-service.service';
import { UserManagementComponent } from './Component/user-management/user-management.component';
import { PowerUserListComponent } from './Component/user-management/power-user-list/power-user-list.component';
import { PowerUserRegistrationComponent } from './Component/user-management/power-user-registration/power-user-registration.component';
import { AssignRolesToPowerUserComponent } from './Component/user-management/assign-roles-to-power-user/assign-roles-to-power-user.component';
import { EditPowerUserComponent } from './Component/user-management/edit-power-user/edit-power-user.component';
import { EditAssignRoleToPowerUserComponent } from './Component/user-management/edit-assign-role-to-power-user/edit-assign-role-to-power-user.component';
import { ChangePowerUserRoleStatusComponent } from './Component/user-management/change-power-user-role-status/change-power-user-role-status.component';
import { CallbackPipe } from './callback.pipe';
import { ContentStudymaterialStatuslistComponent } from './Component/content-management/content-studymaterial-statuslist/content-studymaterial-statuslist.component';
import { ContentStudymaterialreportsComponent } from './Component/content-management/content-studymaterialreports/content-studymaterialreports.component';
import { ContentStudyunitReportComponent } from './Component/content-management/content-studyunit-report/content-studyunit-report.component';
// import { UserSetPasswordComponent } from './Component/user-management/user-set-password/user-set-password.component';
import { UserValidateAccountComponent } from './Component/user-management/user-validate-account/user-validate-account.component';
import { UserloginComponent } from './Component/userlogin/userlogin.component';
import { AdminDashboardComponent } from './Component/admin-dashboard/admin-dashboard.component';
import { AuthGuard } from './guard/guards/auth.guard';
import { AuthInterceptor } from './Services/services/auth.interceptor';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { ContentRatingComponent } from './Component/content-management/content-rating/content-rating.component';
import { ExamManagementComponent } from './Component/exam-management/exam-management.component';
import { ExamAgenciesComponent } from './Component/exam-management/exam-agencies/exam-agencies.component';
import { AnswerChoiceSolutionHintComponent } from './Component/question-management/answer-choice-solution-hint/answer-choice-solution-hint.component';
import { RelocateQuestionComponent } from './Component/question-management/relocate-question/relocate-question.component';
import { QuestionPreviewAppeanranceComponent } from './Component/question-management/question-preview-appeanrance/question-preview-appeanrance.component';
import { QuestionUsageSettingComponent } from './Component/question-management/question-usage-setting/question-usage-setting.component';
import { ExamInstanceSubjectListComponent } from './Component/exam-management/exam-instance-subject-list/exam-instance-subject-list.component';
import { ExamInstanceSubjectWiseTopicsComponent } from './Component/exam-management/exam-instance-subject-wise-topics/exam-instance-subject-wise-topics.component';
// import { HttpInterceptorService } from './Services/http-interceptor.service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { LoaderComponent } from './Component/Loader/loader/loader.component';
import { LoaderInterceptor } from './Component/Loader/loader.interceptor';
import { LoaderService } from './Component/Loader/loader.service';
import { TinymceComponent } from './Component/tinymce/tinymce.component';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { FullscreenOverlayContainer } from '@angular/cdk/overlay';
import { TinyedneditorComponent } from './Component/tinyedneditor/tinyedneditor.component';
import { QuestionMonthlyReportComponent } from './Component/question-management/question-monthly-report/question-monthly-report.component';
import { QuestionStatusReportComponent } from './Component/question-management/question-status-report/question-status-report.component';
import { QuestionExternalReferencesReportComponent } from './Component/question-management/question-external-references-report/question-external-references-report.component';
import { AddEditExamAgencyComponent } from './Component/exam-management/exam-agencies/add-edit-exam-agency/add-edit-exam-agency.coponent';
import { CourseMasterComponent } from './Component/exam-management/exam-agencies/course-master-add-edit/course-master-add-edit.component';
import { CloneCourseModalComponent } from './Component/exam-management/exam-agencies/course-master-add-edit/clone-course-modal/clone-course-modal.component';
import { PreviewTextComponent } from './Component/exam-management/exam-agencies/course-master-add-edit/preview/preview-text.component';

// import { DeviceDetectorModule } from 'ngx-device-detector';
//import { SortablejsModule } from "angular-sortablejs";
// import { AngularFontAwesomeModule } from 'angular-font-awesome';

import { AnswerChoiceAddEditComponent as FAAnswerChoiceAddEditComponent } from './Component/fa-management/answer-choice-add-edit/answer-choice-add-edit.component';
import { AnswerChoiceNoteComponent as FAAnswerChoiceNoteComponent } from './Component/fa-management/answer-choice-note/answer-choice-note.component';
import { AnswerChoiceSolutionHintComponent as FAAnswerChoiceSolutionHintComponent } from './Component/fa-management/answer-choice-solution-hint/answer-choice-solution-hint.component';
import { QuestionBodyAddEditComponent as FAQuestionBodyAddEditComponent } from './Component/fa-management/question-body-add-edit/question-body-add-edit.component';
import { FlashcardExternalReferencesReportComponent } from './Component/fa-management/flashcard-external-references-report/flashcard-external-references-report.component';
import { QuestionListComponent as FAQuestionListComponent } from './Component/fa-management/question-list/question-list.component';
import { QuestionMonthlyReportComponent as FAQuestionMonthlyReportComponent } from './Component/fa-management/question-monthly-report/question-monthly-report.component';
import { QuestionPreviewComponent as FAQuestionPreviewComponent } from './Component/fa-management/question-preview/question-preview.component';
import { QuestionPreviewAppeanranceComponent as FAQuestionPreviewAppeanranceComponent } from './Component/fa-management/question-preview-appeanrance/question-preview-appeanrance.component';
import { QuestionSubmitForReviewComponent as FAQuestionSubmitForReviewComponent } from './Component/fa-management/question-submit-for-review/question-submit-for-review.component';
import { QuestionUsageSettingComponent as FAQuestionUsageSettingComponent } from './Component/fa-management/question-usage-setting/question-usage-setting.component';
import { QuestionstatusHistoryComponent as FAQuestionstatusHistoryComponent } from './Component/fa-management/questionstatus-history/questionstatus-history.component';
import { RelocateQuestionComponent as FARelocateQuestionComponent } from './Component/fa-management/relocate-question/relocate-question.component';
import { CourseAddEditComponent } from './Component/exam-management/exam-agencies/course-add-edit/course-edit-add.component';
import { ExamInstanceSubjectWiseTopicsCAComponent } from './Component/exam-management/exam-agencies/course-add-edit/exam-instance-subjects/exam-instance-subject-wise-topics/exam-instance-subject-wise-topics.component';
import { ExamInstanceSubjectsCAComponent } from './Component/exam-management/exam-agencies/course-add-edit/exam-instance-subjects/exam-instance-subjects/exam-instance-subjects.component';
import { ExamInstanceSubjectListCAComponent } from './Component/exam-management/exam-agencies/course-add-edit/exam-instance-subjects/exam-instance-subject-list/exam-instance-subject-list.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ContentManagementNavigatorComponent } from './Component/master/content-management-navigator/content-management-navigator.component';
import { ContentManagementCloneSubjectSelectorComponent } from './Component/content-management/content-management-clone-subject-selector/content-management-clone-subject-selector.component';
import { NgxMaskModule, IConfig } from 'ngx-mask';

import { TwoDigitDecimaNumberDirective } from './directives/decimalPlaces.directive';
import { NumericInputDirective } from './directives/numeric-input.directive';
import { QuestionAssignModalComponent } from './Component/question-management/question-add-edit/question-assign-modal/question-assign-modal.component';
import { FlashcardAssignModalComponent } from './Component/fa-management/question-add-edit/flashcard-assign-modal/flashcard-assign-modal.component';
import { QuestionRelationModalComponent } from './Component/question-management/question-add-edit/question-relation-modal/question-relation-modal.component';
import { AssignStudymaterialModalComponent } from './Component/content-management/assign-studymaterial-modal/assign-studymaterial-modal.component';
import { ShufflingQuestionModalComponent } from './Component/question-management/question-add-edit/shuffling-question-modal/shuffling-question-modal.component';
import { ShufflingFlashcardComponent } from './Component/fa-management/question-add-edit/shuffling-flashcard/shuffling-flashcard.component';
import { SharedModule } from './shared.module';
import { FlashcardListModalComponent } from './Component/fa-management/flashcard-list-modal/flashcard-list-modal.component';
import { QuestionListModalComponent } from './Component/question-management/question-list-modal/question-list-modal.component';
import { StudyUnitDisplayOrderComponent } from './Component/content-management/study-unit-display-order/study-unit-display-order.component';
import { RelocateTopicContentComponent } from './Component/content-management/relocate-topic-content/relocate-topic-content.component';
import { MockExamsComponent } from './Component/exam-management/mock-exams/mock-exams.component';
import { AddEditMockExamModalComponent } from './Component/exam-management/add-edit-mock-exam-modal/add-edit-mock-exam-modal.component';
import { ChangeCourseHeaderComponent } from './Component/exam-management/exam-agencies/change-course-header/change-course-header.component';
import { MockExamQuestionComponent } from './Component/exam-management/exam-agencies/mock-exam-question/mock-exam-question.component';
import { AddEditMockExamQuestionComponent } from './Component/exam-management/add-edit-mock-exam-question/add-edit-mock-exam-question.component';
import { FilePreviewModalComponent } from './common/file-preview-modal/file-preview-modal.component';
import { ConfirmRelocateModalComponent, QuestionTopicsNodeComponent, RelocateQuestionModalComponent } from './Component/question-management/relocate-question-modal/relocate-question-modal.component';
import { QuestionCardComponent } from './Component/question-management/question-card/question-card.component';
import { CourseFeatureAvailabillityModalComponent } from './Component/exam-management/exam-agencies/course-add-edit/course-feature-availabillity-modal/course-feature-availabillity-modal.component';
import { AssignPracticeQuestionStudyMaterialComponent } from './Component/question-management/assign-practice-question-study-material/assign-practice-question-study-material.component';
import { QuestionRelocateTreeModalComponent } from './Component/question-management/question-relocate-tree-modal/question-relocate-tree-modal.component';
import { PoweruserChangeStatusComponent } from './Component/user-management/poweruser-change-status/poweruser-change-status.component';
import { StudymaterialPratciceTestComponent } from './Component/exam-management/studymaterial-pratcice-test/studymaterial-pratcice-test.component';
import { AddStudymaterialPracticeTestComponent } from './Component/exam-management/add-studymaterial-practice-test/add-studymaterial-practice-test.component';
import { AssignStudyunitToPracticeTestComponent } from './Component/exam-management/assign-studyunit-to-practice-test/assign-studyunit-to-practice-test.component';
import { StudyunitPracticeTestQuestionsComponent } from './Component/exam-management/studyunit-practice-test-questions/studyunit-practice-test-questions.component';
import { AddEditStudyunitPracticeQuestionComponent } from './Component/exam-management/add-edit-studyunit-practice-question/add-edit-studyunit-practice-question.component';
import { QuestionMultipleAssignComponent } from './Component/question-management/question-add-edit/question-multiple-assign/question-multiple-assign.component';
import { TinyEditorModalComponent } from './common/tiny-editor-modal/tiny-editor-modal.component';
import { NotificationAddEditComponent } from './Component/notification-management/notification-add-edit/notification-add-edit.component';
import { NotificationComponent } from './Component/notification-management/notification/notification.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { Router } from '@angular/router';
import { LastRouteService } from './Services/last-route.service';
import { AuthService } from './Services/services/auth.service';
import { StudyUnitMainTopicDisplayOrderComponent } from './Component/content-management/study-unit-main-topic-display-order/study-unit-main-topic-display-order.component';
import { CourseMainTopicAddEditComponent } from './Component/content-management/course-main-topic-add-edit/course-main-topic-add-edit.component';
import { WeeklypracticetestComponent } from './Component/exam-management/exam-agencies/weeklypracticetest/weeklypracticetest.component';
import { AddEditWeeklyPracticeTestModalComponent } from './Component/exam-management/add-edit-weekly-practice-test-modal/add-edit-weekly-practice-test-modal.component';
import { WeeklyPracticeTestQuestionsComponent } from './Component/exam-management/exam-agencies/weekly-practice-test-questions/weekly-practice-test-questions.component';
import { WeeklyPracticeTestStudyUnitSelectionComponent } from './Component/exam-management/exam-agencies/weekly-practice-test-study-unit-selection/weekly-practice-test-study-unit-selection.component';
import { WeeklyPracticeTestQuestionSelectionComponent } from './Component/exam-management/exam-agencies/weekly-practice-test-question-selection/weekly-practice-test-question-selection.component';
import { StudyUnitPracticeQuestionReportTableComponent } from './Component/content-management/study-unit-practice-question-report-table/study-unit-practice-question-report-table.component';
export const options: Partial<IConfig> | (() => Partial<IConfig>) = {
  validation: true,
  allowNegativeNumbers: true,
};

declare const require: any;
(window as any).tinymce = require('tinymce');

//    // import synchronous mathtype-tinymce5 package
require('node_modules/@wiris/mathtype-tinymce6');
require('src/assets/plugins/codecogs/eqneditor.js');


export function restoreRouteOnBoot(auth: AuthService, last: LastRouteService, router: Router) {
  return async () => {
    if (!localStorage.getItem('userToken')) return;
    const url = last.get();
    if (url && url !== router.url) await router.navigateByUrl(url);
  };
}
export const RESTORE_ROUTE_PROVIDER: Provider = {
  provide: APP_INITIALIZER,
  multi: true,
  deps: [AuthService, LastRouteService, Router],
  useFactory: restoreRouteOnBoot
};

@NgModule({
  declarations: [
    // CustomFormsModule
    // Flash Card
    // RteWorksComponent,
    // SortHeader Class
    AddEditExamAgencyComponent,
    AddEditMockExamModalComponent,
    AddEditMockExamQuestionComponent,
    AdminDashboardComponent,
    AnswerChoiceAddEditComponent,
    AnswerChoiceNoteComponent,
    AnswerChoiceSolutionHintComponent,
    AppComponent,
    AssignRolesToPowerUserComponent,
    AssignStudymaterialModalComponent,
    CallbackPipe,
    ChangeCourseHeaderComponent,
    ChangePowerUserRoleStatusComponent,
    ContentAddEditStudymaterialComponent,
    ContentForReviewComponent,
    ContentManagementComponent,
    ContentManagementNavigatorComponent,
    ContentManagementCloneSubjectSelectorComponent,
    ContentManagementTreeComponent,
    ContentPreviewComponent,
    ContentRatingComponent,
    ContentReviewcommentsComponent,
    ContentStudymaterialListComponent,
    ContentStudymaterialreportsComponent,
    ContentStudymaterialStatuslistComponent,
    ContentStudyUnitComponent,
    ContentStudyunitReportComponent,
    ContentStudyUnitSubjectComponent,
    ContentStudyunitTopicsComponent,
    ContentStudyunitTopicsNodeComponent,
    CourseAddEditComponent,
    CourseMasterComponent,
    CloneCourseModalComponent,
    EditAssignRoleToPowerUserComponent,
    EditPowerUserComponent,
    ExamAgenciesComponent,
    ExamInstanceSubjectListCAComponent,
    ExamInstanceSubjectListComponent,
    ExamInstanceSubjectsCAComponent,
    ExamInstanceSubjectWiseTopicsCAComponent,
    ExamInstanceSubjectWiseTopicsComponent,
    ExamManagementComponent,
    FAAnswerChoiceAddEditComponent,
    FAAnswerChoiceNoteComponent,
    FAAnswerChoiceSolutionHintComponent,
    FAQuestionBodyAddEditComponent,
    FlashcardExternalReferencesReportComponent,
    FAQuestionListComponent,
    FAQuestionMonthlyReportComponent,
    FAQuestionPreviewAppeanranceComponent,
    FAQuestionPreviewComponent,
    FAQuestionstatusHistoryComponent,
    FAQuestionSubmitForReviewComponent,
    FAQuestionUsageSettingComponent,
    FARelocateQuestionComponent,
    FilePreviewModalComponent,
    FlashcardAssignModalComponent,
    FlashcardListModalComponent,
    LoaderComponent,
    MasterComponent,
    MockExamQuestionComponent,
    MockExamsComponent,
    StudymaterialPratciceTestComponent,
    AddStudymaterialPracticeTestComponent,
    NumericInputDirective,
    PdfViewerComponent,
    PowerUserListComponent,
    PowerUserRegistrationComponent,
    PreviewTextComponent,
    QuestionAssignModalComponent,
    QuestionMultipleAssignComponent,
    QuestionBodyAddEditComponent,
    QuestionListComponent,
    QuestionListModalComponent,
    QuestionManagementComponent,
    QuestionMasterComponent,
    QuestionMonthlyReportComponent,
    QuestionExternalReferencesReportComponent,
    QuestionPreviewAppeanranceComponent,
    QuestionPreviewComponent,
    QuestionRelationModalComponent,
    QuestionstatusHistoryComponent,
    QuestionStatusReportComponent,
    QuestionSubmitForReviewComponent,
    QuestionUsageSettingComponent,
    QuillRTEComponent,
    RelocateQuestionComponent,
    RelocateTopicContentComponent,
    RoutingComponents,
    QuestionRelocateTreeModalComponent,
    ShufflingFlashcardComponent,
    ShufflingQuestionModalComponent,
    StudyUnitDisplayOrderComponent,
    SubjectManagementComponent,
    TinyedneditorComponent,
    TinymceComponent,
    TwoDigitDecimaNumberDirective,
    UserloginComponent,
    UserManagementComponent,
    UserValidateAccountComponent,
    RelocateQuestionModalComponent,
    QuestionTopicsNodeComponent,
    QuestionCardComponent,
    ConfirmRelocateModalComponent,
    CourseFeatureAvailabillityModalComponent,
    AssignPracticeQuestionStudyMaterialComponent,
    PoweruserChangeStatusComponent,
    AssignStudyunitToPracticeTestComponent,
    StudyunitPracticeTestQuestionsComponent,
    AddEditStudyunitPracticeQuestionComponent,
    TinyEditorModalComponent,
    NotificationAddEditComponent,
    NotificationComponent,
    StudyUnitMainTopicDisplayOrderComponent,
    CourseMainTopicAddEditComponent,
    WeeklypracticetestComponent,
    AddEditWeeklyPracticeTestModalComponent,
    WeeklyPracticeTestQuestionsComponent,
    WeeklyPracticeTestStudyUnitSelectionComponent,
    WeeklyPracticeTestQuestionSelectionComponent,
    StudyUnitPracticeQuestionReportTableComponent
  ],
  imports: [
    // AngularFontAwesomeModule,
    EditorModule,
    NgxSpinnerModule,
    DragDropModule,
    ScrollingModule,
    FormsModule,
    PdfViewerModule,
    NgxDocViewerModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    SharedModule,
    NgxMaskModule.forRoot(options),
    // SortablejsModule,
    // SortablejsModule.forRoot({ animation: 200 }),
    //  CustomFormsModule,
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,

    // RichTextEditorModule,
    //ToastrModule.forRoot(),
    ToastrModule.forRoot({
      closeButton: true,
      timeOut: 10000, // 15 seconds
      progressBar: true,
    }),
    QuillModule.forRoot(),
    NgIdleKeepaliveModule.forRoot(),
    // DeviceDetectorModule.forRoot(),
  ],
  providers: [
    // ToolbarService, LinkService, ImageService, HtmlEditorService,FileManagerService,TableService,
    HttpErrorHandlerService,
    SampleService,
    MessageServiceService,
    AppConfig,
    AppOfflineStore,
    DatePipe,
    CompressionServiceService,
    RESTORE_ROUTE_PROVIDER,
    AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' },
    LoaderService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}


